var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"policy"},[_c('h1',[_vm._v(_vm._s(_vm.privacyAgreement.chineseTitle))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.privacyAgreement.imageContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }